import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from "@activecollab/components";
import PropTypes from "prop-types";
import { showSuccessToast } from "~/components/Toast";
import { invalidateTemplateDependenciesCount } from "~/repository";
import { DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS } from "~/store/action_types";
import { deleteProjectTemplateElement } from "~/store/actions/actions.projectTemplateElements";
import { useProjectTemplateContext } from "./context";
import { PROJECT_TEMPLATE_SUBTASK, resolvedLabel, TEMPLATE_ELEMENTS_LABELS } from "./utils";

const DeleteTemplateElementDialog = ({ type, deleteElementId, setDeleteElementId, templateId, disableRedirect }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { singlePage } = useProjectTemplateContext();
  const [isDeleting, setIsDeleting] = useState(false);

  const resolvedLabels = useMemo(() => resolvedLabel(type, t), [t, type]);

  const successToastMessage = useMemo(() => t(`${TEMPLATE_ELEMENTS_LABELS[type]} deleted.`), [t, type]);

  const handleElementDelete = () => {
    setIsDeleting(true);
    dispatch(deleteProjectTemplateElement(deleteElementId, templateId, type)).then((res) => {
      setIsDeleting(false);
      if (res.type === DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS) {
        setDeleteElementId(null);
        invalidateTemplateDependenciesCount(templateId);
        if (singlePage && type !== PROJECT_TEMPLATE_SUBTASK) {
          showSuccessToast(successToastMessage);
        }
        !disableRedirect && navigate("/projects/templates/" + templateId, { state: { edit: false } });
      }
    });
  };

  return (
    <ConfirmDialog
      open={!!deleteElementId}
      onCancel={() => setDeleteElementId(null)}
      onConfirm={handleElementDelete}
      dialogTitle={resolvedLabels.title}
      dialogContent={resolvedLabels.content}
      confirmBtnText={t("Delete")}
      cancelBtnText={t("Cancel")}
      isLoading={isDeleting}
    />
  );
};

DeleteTemplateElementDialog.propTypes = {
  type: PropTypes.string,
  deleteElementId: PropTypes.number,
  setDeleteElementId: PropTypes.func,
  templateId: PropTypes.number,
  disableRedirect: PropTypes.bool,
};

export default DeleteTemplateElementDialog;
